
import Vue from 'vue'
import EmailValidation from '@/service/EmailValidation'
import BackgroundLayout from '@/components/BackgroundLayout.vue'
import ExpandableText from '@/components/ExpandableText.vue'

export default Vue.extend({
  name: 'Contact',
  components: {
    BackgroundLayout,
    ExpandableText,
  },
  async mounted() {
    const promises = [
      this.$api
        .get('/contents/contact')
        .then((result) => {
          this.title = result.data.title
          this.subtitle = result.data.subtitle
          const plainText = this.stripHtml(result.data.informationClause);
          this.consentShort = plainText.length > 215
            ? plainText.substring(0, 215) + '...'
            : result.data.informationClause;
          this.consentLong = result.data.informationClause;
          this.content = result.data.content;
        }),
    ]

    Promise.all(promises).then(() => (this.contentLoaded = true))
  },
  data: () => ({
    title: "",
    subtitle: "",
    content: "",
    consentShort: '',
    consentLong: '',
    contentLoaded: false,
    sendLoading: false,
    name: '',
    email: '',
    message: '',
    nameRules: [(v: string) => !!v || 'Your name is required.'],
    emailRules: [
      (v: string) => !!v || 'Your e-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    messageRules: [(v: string) => !!v || 'Message is required.'],
  }),
  methods: {
    stripHtml(html: string): string {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    sendEmail: async function () {
      this.sendLoading = true
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('contact')
      this.$api
        .post('/contact', {
          name: this.name,
          email: this.email,
          message: this.message,
          captchaToken: token,
        })
        .then((response) => {
          this.name = ''
          this.email = ''
          this.message = ''
          ;(this.$refs.contactFormRef as any).resetValidation()
          this.$store.dispatch(
            'alert/success',
            'Message has been sent. We will try to reply as soon as possible.'
          )
        })
        .catch(() =>
          this.$store.dispatch('alert/error', 'Problems with sending message.')
        )
        .finally(() => (this.sendLoading = false))
    },
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge()
  },
})
